import * as React from "react";
import classNames from "classnames";

import {IIcon} from "../../IIcon";
import {SvgIcon} from "./SvgIcon";

export const EyeIcon = (props: IIcon) => {
    const {fillColor, size, wrapperColor, wrapperSize} = props;
    const className = classNames(props.className);

    return (
        <SvgIcon size={size || "1"} className={className} fillColor={fillColor} wrapperColor={wrapperColor} wrapperSize={wrapperSize}>
            <path d="M5,1.44A5.32,5.32,0,0,0,.05,4.82a5.32,5.32,0,0,0,9.9,0A5.32,5.32,0,0,0,5,1.44ZM5,7.07A2.25,2.25,0,1,1,7.25,4.82,2.25,2.25,0,0,1,5,7.07Zm0-3.6A1.35,1.35,0,1,0,6.35,4.82,1.34,1.34,0,0,0,5,3.47Z" />
        </SvgIcon>
    );
};
